import React, { forwardRef } from 'react';
import cx from 'classnames';
import { Box, Grid, Typography } from '@mui/material';
import ReportHeader from '../ReportHeader/ReportHeader';
import ReportBreakdown from '../ReportBreakdown/ReportBreakdown';
// import { Constants, DateUtils } from '../../../../utils';
import { Constants } from '../../../../utils';
import { ISummaryReport, breakdownReportState, IBreakdownReport } from '../../../../interfaces/calculator.interface';
import { IInterventionsChecklist } from '../../../../interfaces/interventions.interface';
import useStyles from './Report.styles';
import TotalSavingsByPopulation from '../TotalSavings/TotalSavingsByPopulation';
import TotalSavingsByTimeframe from '../TotalSavings/TotalSavingsByTimeframe';
import ROIBySavings from '../ReturnOnInvestment/ROIBySavings';
import ROIByServiceProvider from '../ReturnOnInvestment/ROIByServiceProvider';
import CostSavingsReportBreakdown from '../ReportBreakdown/CostSavingsReportBreakdown';
import SavingsBySector from '../ReturnOnInvestment/SavingsBySector';
import ReportFooter from '../ReportBreakdown/ReportFooter';

interface IProps {
  report: ISummaryReport;
  interventionsChecklist: IInterventionsChecklist;
  id?: string;
  printClass?: string;
  isFinished: boolean;
  lastDateUpdated: string;
  titleText?: string;
}

const Report = forwardRef<HTMLDivElement, IProps>(
  ({ id, report, interventionsChecklist, printClass, isFinished, lastDateUpdated, titleText }, ref) => {
    const classes = useStyles();

    const sanitizeReportValues = (reportToParse: IBreakdownReport) => {
      if (!reportToParse) return breakdownReportState;

      return Object.entries(reportToParse)
        .reduce((acc, [key, val]) => {
          const isNote = key.toLowerCase().includes('note');
          
          return ({
            ...acc,
            [key]: (val === '' && !isNote) ? Constants.STRING_TYPES.EMPTY : val,
          });
        },
        breakdownReportState);
    };

    // const getReportDate = () => 
    //   lastDateUpdated ?
    //     (isFinished ? 'Completed on ' : 'Last Edited on ') + DateUtils.formatDate(new Date(lastDateUpdated), 'MM/DD/YYYY | hh:mm a')
    //     : '';

    return (
      <div
        className={cx(classes.content, {
          [classes.download]: id,
        })}
        ref={ref}
        id={id}
      >

        <ReportHeader report={report} titleText={titleText} printClass= {printClass} />
        {/* <Box className={`${classes.completedDate} ${printClass || ''}`}>{getReportDate()}</Box> */}
        <Box className={classes.topMarginPrint} displayPrint="block" display="none" />     
        <Typography className={cx(classes.sectionTitle, printClass)}>HealthySteps Savings and ROI are restricted to quantifiable cost savings only, and do not include total benefits of HS services.</Typography>
            
        <ROIBySavings report={report} />  
        <Typography className={cx(classes.sectionTitleItalic, printClass)}>
          * Long-term savings reflect those that accrue at least one year after receipt of the given intervention. These savings include a 3% annual discount. Discounting is a method to determine the present value of money received in the future. Dollars are worth more today than in the future, due to value that could be gained through interest if invested or value that would be lost through inflation if not invested. As the majority of savings are within the healthcare sector, we look to the average annual medical CPI (consumer price index) trend from the last ten years (3%) to determine our annual discounting factor.
        </Typography>
         <Typography className={cx(classes.subSectionTitle, printClass)}>
          ** Long-term ROI includes both short- and long-term savings.
        </Typography>
  
        <Grid container spacing={2} style={{ paddingLeft:'35px' }}>
          <Grid size = {{ xs:6 }}>
            <TotalSavingsByPopulation
              report={report}
            />
          </Grid>
          <Grid size = {{ xs:6 }}>
            <TotalSavingsByTimeframe
              report={report}
            />
          </Grid>
        </Grid>
        <ROIByServiceProvider report={report} interventionsChecklist={interventionsChecklist}/>
        <SavingsBySector report={report} interventionsChecklist={interventionsChecklist} printClass={printClass}/>
        {/* <ReportBody report={report} interventionsChecklist={interventionsChecklist} /> */}
        <Box className={classes.pageDivider} displayPrint="block" display="none" />
        <ReportBreakdown
          report={sanitizeReportValues(report.breakdownData)}
          interventionsChecklist={interventionsChecklist}
        />
        <CostSavingsReportBreakdown
          report={sanitizeReportValues(report.breakdownData)}
          interventionsChecklist={interventionsChecklist}
        />
        <ReportFooter
         report={sanitizeReportValues(report.breakdownData)}
          interventionsChecklist={interventionsChecklist}
        />
      </div>
    );
  }
);

export default Report;